import { useEffect, useMemo, useState } from 'react'
import API from '../../api'
import Select from 'react-select'
import isEmpty from 'lodash/isEmpty'
import { defineMessages, injectIntl } from 'react-intl'
import store from 'store2'
import { getDefaultMeasurementUnits, getIdToken } from '../../utils'
import get from 'lodash/get'

const messages = defineMessages({
  otherParticipant: {
    id: 'other_participant',
    defaultMessage: 'Other participant',
  },
  leadBooker: {
    id: 'lead_booker',
    defaultMessage: 'Lead booker (me)',
  },
})

const ParticipantSwitch = ({ intl, onOptionChange, formId, selectedId }) => {
  const [participants, setParticipants] = useState([])
  const [selected, setSelected] = useState(selectedId)
  const [values, setValues] = useState({})

  const preferredUnits = getDefaultMeasurementUnits()
  const user = getIdToken() && store('user')

  const leadUser = useMemo(() => {
    if(user) {
      const contactInformation = get(user, 'contactInformation', {})
      const diveGearRentalInfo = get(user, 'diveGearRentalInfo', {})
      const diveExperience = get(user, 'diveExperience', {})
      return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        countryId: user.countryId,
        ...contactInformation,
        ...diveGearRentalInfo,
        ...diveExperience,
        certifyingAgency: diveExperience && diveExperience.certifyingAgencyId,
        heightUnit: diveGearRentalInfo && diveGearRentalInfo.distanceHeightUnit,
      }
    }
    return { ...preferredUnits }
  }, [])

  useEffect(() => {
    if(!isEmpty(user)) {
      API('/api/adventure/v1/account/buddies/')
        .get()
        .then((res) => {
          setParticipants([...res, ...getAdditionalParticipants()])
        })
    } else {
      setParticipants([...getAdditionalParticipants()])
    }
  }, [])

  useEffect(() => {
    onOptionChange(formId, values)
  }, [values])

  useEffect(() => {
    if(selected && selected !== 'other_participant') {
      API(`/api/adventure/v1/account/buddies/${selected}`)
        .get()
        .then((res) => setValues(res))
    } else if(selected === 'other_participant') {
      setValues({ ...getDefaultMeasurementUnits() })
    } else {
      setValues({ ...leadUser })
    }
  }, [selected])

  const handleChange = (option) => {
    setSelected(option.value)
  }

  const getAdditionalParticipants = () => {
    return [
      {
        firstName: intl.formatMessage(messages.leadBooker),
        id: 0,
      },
      {
        firstName: intl.formatMessage(messages.otherParticipant),
        id: 'other_participant',
      },
    ]
  }

  const getParticipantsOptions = () => {
    return participants
      .map((item) => {
        return {
          value: item.id,
          label: `${item.firstName} ${item.lastName || ''}`,
        }
      })
      .sort((a, b) => a.value - b.value)
  }

  const selectedObj = getParticipantsOptions().find(
    (option) => option.value === selected
  )

  return (
    <div className='participant-switch dropdown-wrapper'>
      <Select
        value={selectedObj}
        onChange={handleChange}
        options={getParticipantsOptions()}
        className='select-container'
        classNamePrefix='select-container'
      />
    </div>
  )
}

export default injectIntl(ParticipantSwitch)
